import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/balances")({
  beforeLoad: () => {
    throw redirect({ to: "/expenses" });
  },
});
